import { mapProjectRates } from '~/modules/rateCard/advancedRateCard/components/hooks/utils';
import { CostOverrideType } from '../CostOverrideType';

export const mapCostOverrideRates = (
  projectRates,
  projectDimensions,
  loadingMore
) =>
  mapProjectRates(projectRates, projectDimensions, loadingMore).map(rate => {
    const hasAmount =
      rate.amount?.amount !== null && rate.amount?.amount !== undefined;
    const hasPercentMarkup =
      rate.percentMarkup !== null && rate.percentMarkup !== undefined;

    const isPercentMarkup = !hasAmount && hasPercentMarkup;

    return {
      ...rate,
      type: isPercentMarkup
        ? CostOverrideType.PERCENT_MARKUP
        : CostOverrideType.HOURLY_RATE,
      percent: isPercentMarkup ? rate.percentMarkup : 0
    };
  });

export default mapCostOverrideRates;
